import { API_BASE_URL } from "../../config";

async function fetchRedbookSummary() {
  try {
    const response = await fetch(`${API_BASE_URL}/redbook/summary`);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching Redbook summary:', error);
    return null;
  }
}

export async function fetchTopicDetail(topicId) {
  try {
    const response = await fetch(`${API_BASE_URL}/redbook/topic/${topicId}`);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(`Error fetching Redbook topic ${topicId}:`, error);
    return null;
  }
}

export const redbookSummary = await fetchRedbookSummary();
